import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject, Unsubscribable } from 'rxjs';

import { UserAuth, ValuesExchangeProvider } from '@nrwl/common-lib';
import { NavigationProvider } from '@nrwl/navigation-abstract';

import { UserAdministrationService } from '../../../services/user.administration.service';

@Component({
  selector: 'nrwl-roles-groups',
  templateUrl: './roles-groups.component.html',
  styleUrls: ['./roles-groups.component.scss']
})
export class RolesGroupsComponent implements OnInit, AfterViewInit, OnDestroy {
  userName: string;
  userId: string;
  userIsMyself: boolean;
  currentUser: any; //eslint-disable-line
  userInfo: any = {}; //eslint-disable-line
  defaultRoleId = 'default_role';

  private readonly unsubscribe: Subject<void> = new Subject();
  private userInfoUnsubscribable: Unsubscribable;
  private navigationSubscription: Unsubscribable;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly userAuth: UserAuth,
    private readonly navigator: NavigationProvider,
    private router: Router,
    private exchange: ValuesExchangeProvider,
    private userAdministrationService: UserAdministrationService
  ) {
    this.currentUser = this.userAuth.getUserAuth();
  }

  ngOnInit() {
    this.userName = this.activatedRoute.snapshot.queryParams['userName'] ?? this.activatedRoute.snapshot.params['userName'] ?? '';
    this.userId = this.activatedRoute.snapshot.queryParams['uid'] ?? '';
    this.userIsMyself = !this.userName || this.currentUser?.data?.USER_ID === this.userName;
    this.getMe();
    //eslint-disable-next-line
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        if (e.url === '/profile') {
          this.exchange.notifyListeners('user-profile-loading', true);
          this.getMe();
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.userInfoUnsubscribable = this.exchange.registerInterest(
      'user-profile-role-group-update-done',
      isDone => {
        if (isDone) {
          this.getMe();
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    if (this.userInfoUnsubscribable) {
      this.userInfoUnsubscribable.unsubscribe();
    }
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  isEditable(): boolean {
    return this.userInfo.origin === 'local' && this.userAuth.isAuthedFor('MANAGE_PERMISSIONS') && !this.userAuth.readOnly;
  }

  //eslint-disable-next-line
  getRoleFriendlyName(id: any): any {
    return this.userAuth.getRoleFriendlyName(id);
  }

  openAddandRemoveUserWizard(wizardId: string): void {
    const defaultParams = {
      userNames: [this.userInfo.username],
      id: this.userInfo.id,
      groupIds: this.userInfo.groups,
      add_remove_group: 'add_remove_group'
    };
    this.navigator.navigateToWizard([wizardId], {
      queryParams: {
        defaultParams: JSON.stringify(defaultParams)
      }
    });
  }

  private getMe() {
    if (this.userIsMyself) {
      this.userAdministrationService
      .getMe$()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(result => {
        this.userInfo = result.success;
        this.userAuth.removeRoles(this.userInfo.effectiveRoles);
      }),
      () => {};
    }
    else {
      this.getUser(this.userId);
    }
  }

  private getUser(userId:string) {
    this.userAdministrationService
      .getUser$(userId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(result => {
        this.userInfo = result.success;
        this.userAuth.removeRoles(this.userInfo.effectiveRoles);
      }),
      () => {};
  }
    
}
